import { render, staticRenderFns } from "./PageGroupForm.vue?vue&type=template&id=2315320d&scoped=true"
import script from "./PageGroupForm.vue?vue&type=script&lang=js"
export * from "./PageGroupForm.vue?vue&type=script&lang=js"
import style0 from "./PageGroupForm.vue?vue&type=style&index=0&id=2315320d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2315320d",
  null
  
)

export default component.exports